import { Provider } from '@angular/core';
import { TenantComponentsRestApi } from './infrastructure/api/tenant-components-rest.api';
import { GetTenantComponentsUseCase } from './application/use-cases/get-tenant-components/get-tenant-components.use-case';
import { UpdateTenantComponentsUseCase } from './application/use-cases/update-tenant-components/update-tenant-components.use-case';

export const TENANT_COMPONENTS_PROVIDERS: Provider[] = [
  TenantComponentsRestApi,
  GetTenantComponentsUseCase,
  UpdateTenantComponentsUseCase,
];
